/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagRightIcon32Regular = forwardRef('ArrowDim1DiagRightIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M18 3a1 1 0 1 0 0 2h7.586L5 25.586V18a1 1 0 1 0-2 0v8a3 3 0 0 0 3 3h8a1 1 0 1 0 0-2H6.414L27 6.414V14a1 1 0 1 0 2 0V6a3 3 0 0 0-3-3h-8Z" })));
});
